module.exports = {"430281002":"阳三石街道","430281003":"仙岳山街道","430281004":"国瓷街道","430281006":"来龙门街道","430281102":"白兔潭镇","430281103":"浦口镇","430281105":"王仙镇","430281107":"泗汾镇","430281108":"沈潭镇","430281109":"船湾镇","430281120":"均楚镇","430281121":"东富镇","430281122":"石亭镇","430281125":"孙家湾镇","430281126":"官庄镇","430281127":"嘉树镇","430281128":"板杉镇","430281129":"沩山镇","430281130":"枫林镇","430281131":"李畋镇","430281132":"明月镇","430281133":"左权镇","430281134":"茶山镇","430281400":"湖南醴陵经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430281.json
// module id = 1669
// module chunks = 0